import React, { memo, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import getIcon from '../../utils/iconMapper';
import LazyImage from '../LazyImage';

const ServiceCard = memo(({ service, index, onNavigate }) => {
  const handleClick = useCallback(() => {
    onNavigate(service.link);
  }, [service.link, onNavigate]);

  return (
    <div 
      className={`service-card-modern service-card-${index + 1}`} 
      data-testid={`service-${index}`}
      onClick={handleClick}
    >
      <div className="service-image-modern">
        <LazyImage 
          src={service.image_url} 
          alt={service.title}
          className="service-img-lazy"
        />
        <div className="service-overlay-modern"></div>
      </div>
      <div className="service-content-modern">
        <div className="service-icon-modern">
          {getIcon(service.icon_name, { size: 32 })}
        </div>
        <h3 className="service-title-modern">{service.title}</h3>
        <p className="service-description-modern">
          {service.description}
        </p>
        <div className="service-button-modern">
          <span>Découvrir</span>
          <ArrowRight size={20} />
        </div>
      </div>
    </div>
  );
});

ServiceCard.displayName = 'ServiceCard';

const ServicesSection = memo(({ homeServices }) => {
  const navigate = useNavigate();
  
  const handleNavigate = useCallback((link) => {
    navigate(link);
  }, [navigate]);

  if (!homeServices || homeServices.length === 0) return null;

  return (
    <section id="services" className="services" data-testid="services-section">
      <div className="section-header">
        <h2 className="section-title" data-testid="services-title">NOS SERVICES</h2>
        <p className="section-subtitle">Créations d'exception pour événements de prestige</p>
      </div>

      <div className="services-grid-modern">
        {homeServices.map((service, index) => (
          <ServiceCard 
            key={service.id} 
            service={service} 
            index={index}
            onNavigate={handleNavigate}
          />
        ))}
      </div>
    </section>
  );
});

ServicesSection.displayName = 'ServicesSection';

export default ServicesSection;
